<template>
<div>
    <nav-header :navText="headerText"  />
    <div class="p-4">
        <kendo-datasource ref="remoteDataSource"
        :transport-read-url="apiUrl + '/api/GetAllFutureOrders.php?storeId=' + bid"
        :transport-read-data-type="'json'"
        :transport-read-type="'GET'"
        :schema-model-fields="schemaModelFields"
        :transport-update-data-type="'json'"
        :transport-update-type="'GET'"
        :page-size='pageSize'>
    </kendo-datasource>
    <kendo-button @click="downLoadReport" class="k-primary">Export current view</kendo-button>
    <kendo-button @click="downLoadReportAll" class="k-primary" id="exportAll">Export All</kendo-button>
    <kendo-grid :data-source-ref="'remoteDataSource'" class="mt-4"
                ref="download1"
                :reorderable="true"
                :pageable="true"
                :sortable-mode="'multiple'"
                :groupable="true"
                :sortable-allow-unsort="true"
                :sortable-show-indexes="true"                                    
                :excel-file-name="'OrderAndCollectReport.xlsx'"
                :filterable-mode="'row'">
        <kendo-grid-column :field="'strOrderId'"
        :title="'Store Ref:'"
        :width="50"></kendo-grid-column>

        <kendo-grid-column :field="'strSalutation'"
        :title="'Customer'"
        :width="100"
        ></kendo-grid-column>

                
        <kendo-grid-column :field="'slot_date'"
        :title="'Order Date'"
        :format="'{0:dd/MM/yyyy}'"
        :width="80"></kendo-grid-column>

                
        <kendo-grid-column :field="'slot_time'"
        :title="'Time'"
        :width="50"></kendo-grid-column>

                
        <kendo-grid-column :field="'slot_type'"
        :title="'order Type'"
        :width="80"></kendo-grid-column>

                
        <kendo-grid-column :field="'strSecurityPin'"
        :title="'Pin'"
        :filterable="false"
        :width="40"></kendo-grid-column>

                
        <kendo-grid-column :field="'locker_id'"
        :title="'Locker'"
        :filterable="false"
        :width="40"></kendo-grid-column>

                
        <kendo-grid-column :field="'status'"
        :title="'Order Status'"
        :width="50"></kendo-grid-column>

                
        <kendo-grid-column :field="'fulfilmentStatus'"
        :title="'Order Stage'"
        :width="50"></kendo-grid-column>

                
        <kendo-grid-column :field="'strLastSMSStatus'"
        :title="'SMS Status'"
        :width="50"></kendo-grid-column>
    </kendo-grid>
    </div>
</div>

</template>

<script>
import NavHeader from './NavHeader'
export default {
    name: 'Reports',
    components: {NavHeader},
    props: {
      },    
    data: function()
    {
        return{
            apiUrl: this.$store.state.apiUrl,
            bid:  this.$store.state.bid,
                pageSize: 10,
                headerText: 'Reports',
                schemaModelFields: {
                intDiaryId: { type: 'number' },
                strSalutation: { type: 'string' },
                strOrderId : { type: 'string'},                
                slot_date : { type: 'date'},
                slot_time : { type: 'string'},
                slot_type : { type: 'string'},
                locker_id: { type: 'number'},
                strSecurityPin : { type: 'number'},
                status : { type: 'string'},
                sfulfilmentStatus : { type: 'string'},
                strLastSMSStatus : { type: 'string'}
            }
        }   
    }, 
    methods: {
        downLoadReport: function () {

        var download = this.$refs.download1.kendoWidget()
        download.saveAsExcel()
        },
        downLoadReportAll: function () {
            this.pageSize = 100000
       

        this.$nextTick().then(() => {
            console.log(this.pageSize)
             var download = this.$refs.download1.kendoWidget()
        download.saveAsExcel()
        }).then(setTimeout(() => this.pageSize = 10, 1000))

        

        }
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#exportAll{
    margin-left: 20px
}
</style>
